import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WebsocketEvent } from '../../shared/models/websocket.models';
import { Socket } from 'ngx-socket-io';
import { Notification } from '../../shared/models/users-profile.models';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  private socket = inject(Socket);

  private router = inject(Router);

  private authService = inject(AuthService);

  private toastService = inject(ToastService);

  // private dialogsManagerService = inject(DialogsManagerService);

  constructor() {
    this.socket.on('connect', () => {
      this.attachEventHandlers();
    });

    this.socket.on('disconnect', () => {
      this.detachEventHandlers();
    });
  }

  /** Generic listener for any event */
  listen<T>(eventName: string): Observable<T> {
    return this.socket.fromEvent<T, string>(eventName);
  }

  /** Generic emitter for any event */
  emit<T>(eventName: string, data?: T): void {
    this.socket.emit(eventName, data);
  }

  private eventHandlers: Record<WebsocketEvent, (payload: unknown) => void> = {
    [WebsocketEvent.Notification]: (payload) => {
      const notification = payload as Notification;
      this.toastService.show[notification.level](notification.body, notification.title, {
        payload: notification,
      });
    },
    [WebsocketEvent.RoleUpdated]: (payload) => {
      this.authService.updateUserScopes(payload as string[]);
      this.toastService.info('Your Permissions Have Been Updated');
    },
    [WebsocketEvent.Dialog]: () => {
      // const message = payload as WebsocketDialogMessage;
      // switch (message.type) {
      // case 'success':
      //   return this.dialogsManagerService.showSuccessDialog(message.message);
      // case 'error':
      //   return this.dialogsManagerService.showErrorDialog(message.message);
      // case 'info':
      //   return this.dialogsManagerService.showInfoDialog(message.message);
      // }
    },
    [WebsocketEvent.ForceLogout]: () => {
      this.authService.logout();
      this.socket.disconnect();
      this.router.navigate(['/authentication/login']);
      this.toastService.info('You have been logged out, please login again.', 'FORCE LOGOUT');
    },
    [WebsocketEvent.UpdateCredentials]: () => {
      /* empty */
    },
  };

  private attachEventHandlers(): void {
    Object.entries(this.eventHandlers).forEach(([event, handler]) => {
      this.socket.on(event as WebsocketEvent, handler);
    });
  }

  private detachEventHandlers(): void {
    Object.entries(this.eventHandlers).forEach(([event]) => {
      this.socket.off(event as WebsocketEvent);
    });
  }

  public sendMessage(eventName: string, payload: unknown): void {
    this.socket.emit(eventName, payload);
  }
}
